import { render, staticRenderFns } from "./PasswordCreate.vue?vue&type=template&id=7a4ef8f7&"
import script from "./PasswordCreate.vue?vue&type=script&lang=js&"
export * from "./PasswordCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports